// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import AndroidSvg from '@rsuite/icon-font/lib/platform/Android';
var Android = createSvgIcon({
  as: AndroidSvg,
  ariaLabel: 'android',
  category: 'platform',
  displayName: 'Android'
});
export default Android;